/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component } from '@angular/core';
import { LucideEye, LucideEyeOff } from '@lucide/angular';
import { AlumniLoginComponent } from '../alumni-login/alumni-login.component';

@Component({
  selector: 'ptl-v3-alumni-login',
  templateUrl: './v3-alumni-login.component.html',
  styleUrls: ['./v3-alumni-login.component.scss'],
})
export class V3AlumniLoginComponent extends AlumniLoginComponent {
  protected readonly LucideEye = LucideEye;
  protected readonly LucideEyeOff = LucideEyeOff;
}
